import React from 'react';

import svg from './assets/icons-36-pinterest.svg';
import type { IconProps } from './SvgIcon';
import { SvgIcon } from './SvgIcon';

/** @deprecated Use the Icon component from the design-system-core-components package. */
export const IconPinterest = (props: IconProps) => (
  <SvgIcon {...props} src={svg} testId="icon-pinterest" />
);
